import { render } from "./PurchaseReportContent.vue?vue&type=template&id=d592652c&scoped=true&ts=true"
import script from "./PurchaseReportContent.vue?vue&type=script&lang=ts"
export * from "./PurchaseReportContent.vue?vue&type=script&lang=ts"

import "./PurchaseReportContent.vue?vue&type=style&index=0&id=d592652c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d592652c"]])

export default __exports__